import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import ElementSettingsContext from '../helpers/element-settings-context';
import getBatchValues from '../helpers/get-batch-values';

const { ToggleSection, Box } = designSystem;

function ToggleControl({ id, elementIds, attributes, title, popover = null, onChange }) {
  const { state } = useContext(ElementSettingsContext);

  const flattenedValues = getBatchValues(state, { elementIds, attributes }).flat();
  const isToggleEnabled = flattenedValues.every((value) => value !== false);

  const handleChange = useCallback(
    (value) => {
      onChange({ controlId: id, elementIds, attributes, value });
    },
    [id, elementIds, attributes, onChange]
  );

  return (
    <Box
      paddingTop="spacing-xs"
      paddingBottom="spacing-xs"
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <ToggleSection
        value={isToggleEnabled}
        title={title}
        {...(popover && { popoverProps: popover })}
        onChange={handleChange}
      />
    </Box>
  );
}

ToggleControl.propTypes = {
  id: PropTypes.string.isRequired,
  elementIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributes: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgSrc: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default ToggleControl;
